module.exports = __webpack_public_path__ + "static/media/oral-thumbnail.ed9c9a52.png";